import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SuggestInput from './SuggestInput';

export default class EventVisibilitySelector extends Component {
  static propTypes = {
    options: PropTypes.array,
    initialValue: PropTypes.string,
    groupOptions: PropTypes.object.isRequired,
    eventVisibilityParameter: PropTypes.string,
    eventPublicParameter: PropTypes.string,
  };

  static defaultProps = {
    initialValue: 'community',
    eventVisibilityParameter: 'event[visible]',
    eventPublicParameter: 'event[publicly_available]',
    groupOptions: {},
    options: [
      {
        label: 'Public',
        description: 'Visible to anyone, but community membership is required to RSVP',
        visibility: 'public',
        hidden: false,
      },
      {
        label: 'Community',
        description: 'Visible to anyone in my community',
        visibility: 'community',
        hidden: false,
      },
      {
        label: 'Specific group(s)',
        description: 'Only visible to people in designated groups',
        visibility: 'group',
        hidden: false,
      },
      {
        label: 'Hidden',
        description: 'Only visible to people in the community with the link',
        visibility: 'hidden',
        hidden: true,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedOption: this.props.initialValue,
      showGroupSelection: this.props.initialValue === 'group',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  // When the input value changes (someone selects an option on the radio),
  // update the state to reflect that selected option.
  handleChange = e => {
    this.setState({
      selectedOption: e.target.value,
      showGroupSelection: e.target.value === 'group',
    });
  };

  renderHiddenInputs() {
    return (
      <div>
        <input
          name={this.props.eventVisibilityParameter}
          type="hidden"
          value={this.state.selectedOption !== 'hidden'}
        />
        <input
          name={this.props.eventPublicParameter}
          type="hidden"
          value={this.state.selectedOption === 'public'}
        />
      </div>
    );
  }

  renderGroupSelection() {
    if (this.state.showGroupSelection) {
      return (
        <div className="u-bg-grey-lightest u-border u-rounded u-p-5 u-py-2 u-mt-4">
          <h6>Select groups that have access to this event</h6>
          <SuggestInput {...this.props.groupOptions} />
        </div>
      );
    }

    // This is the cop-out of the widget. Because we're basically offloading
    // group selection to <SuggestInput> we have to still render an empty
    // hidden field to reset groups if the user selects a different visibility
    // option. In that case, we use a prop value that in theory would be passed
    // to <SuggestInput> here.
    //
    // PS: Strong dislike for how we designed the props for that component. Wish
    //     I had time to refactor that one too. - @f
    return <input name={this.props.groupOptions.dataOptions[0].parameter} type="hidden" value="" />;
  }

  render() {
    return (
      <div>
        {this.props.options.map(item => (
          <span className="radio" key={item.visibility}>
            <label htmlFor={item.visibility}>
              <input
                type="radio"
                name="visibility"
                id={item.visibility}
                value={item.visibility}
                onChange={this.handleChange}
                {...item.visibility === this.state.selectedOption && { defaultChecked: true }}
              />
              {item.label}
              <span className="u-text-old-dark-grey">– {item.description}</span>
            </label>
          </span>
        ))}

        {this.renderHiddenInputs()}
        {this.renderGroupSelection()}
      </div>
    );
  }
}
